import { BaseRate } from 'src/app/_models/baseRateItem';
import { BillingService } from './../../_services/billing.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-billing-chart',
  templateUrl: './admin-billing-chart.component.html',
  styleUrls: ['./admin-billing-chart.component.css']
})
export class AdminBillingChartComponent implements OnInit {
  billingList =[]
  loadingBillingCharts=true
  loadingBaseRate=true
  baseRate:BaseRate = undefined
  dtOptions: DataTables.Settings = {};
  constructor(private billingService:BillingService) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers'
     };
    this.loadBillingCharts()
    this.loadBaseRate()
  }
  loadBaseRate(){
    this.billingService.getBaseRate(1).subscribe(
      xxx=>{
        this.baseRate=xxx

        this.loadingBaseRate=false
      }
    )
  }

  loadBillingCharts(){
    this.billingService.getBillingIndex().subscribe(
      x=>{
        this.billingList=x
        this.loadingBillingCharts=false
      }
    )
  }
}
